module.exports = __webpack_public_path__ + "static/media/BM_JobComments.670558dd.svg";